module.exports = __webpack_public_path__ + "media/images/about/bg02-e471633bf8c2d4cae1ce735b61faaef0.jpg";